import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import {PharmacyMapComponent} from "./pharmacy-map.component";

const routes: Routes = [
  {
    path: '',
    component: PharmacyMapComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class PharmacyMapRoutingModule {}
